// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.hyU759h1UcxdEVdyH1EU {
    position: relative;
    background: transparent;
    cursor: pointer;
    padding: 12px;
    border-radius: 100%;
    border: 1px solid black;
}

.hyU759h1UcxdEVdyH1EU:hover {
    border-color: #f26c3a !important;
}

.tZkDC54xmjhwl9JtfyTQ {
    position: absolute !important;
    bottom: 0;
    right: 0;
    line-height: 0 !important;
    height: 18px !important;
    border-radius: 100% !important;
    display: flex !important;
    align-items: center;
    justify-content: center;
    font-size: 11px;
    font-weight: bold;
}

/* SMS Table Styles */
.wUViEn29ROj0pMTpMs7M {
    overflow-x: auto;
    margin-top: 20px;
    border-radius: 8px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.uIDS72ObF_2FMo3aTZ1w {
    width: 100%;
    border-collapse: collapse;
    background: white;
    font-size: 14px;
    table-layout: auto;
}

.uIDS72ObF_2FMo3aTZ1w thead {
    background-color: #f8f9fa;
    border-bottom: 2px solid #dee2e6;
}

.uIDS72ObF_2FMo3aTZ1w th {
    padding: 12px 16px;
    text-align: left;
    font-weight: 600;
    color: #495057;
    border-bottom: 1px solid #dee2e6;
}

.uIDS72ObF_2FMo3aTZ1w td {
    padding: 12px 16px;
    border-bottom: 1px solid #dee2e6;
    vertical-align: top;
    overflow-wrap: break-word;
    word-wrap: break-word;
}

.uIDS72ObF_2FMo3aTZ1w tbody tr:hover {
    background-color: #f8f9fa;
}

.uIDS72ObF_2FMo3aTZ1w tbody tr:last-child td {
    border-bottom: none;
}

/* List-based layout for clickable rows */
.ekLUMPhFM913BP5paZ21 {
    display: grid;
    grid-template-columns: 140px 1fr 180px 120px;
    gap: 12px;
    padding: 12px 16px;
    background-color: #f8f9fa;
    font-weight: 600;
    color: #495057;
    border-bottom: 2px solid #dee2e6;
    font-size: 13px;
}

.ssf6aObccUJtdprzgo2c {
    display: flex;
    flex-direction: column;
}

.RRTgBn8h4LFHCMXBq2Rg {
    display: grid;
    grid-template-columns: 140px 1fr 180px 120px;
    gap: 12px;
    align-items: start;
    padding: 12px 16px;
    background: white;
    border-bottom: 1px solid #dee2e6;
    cursor: pointer;
    text-decoration: none;
    color: inherit;
    transition: background-color 0.12s ease-in-out;
}

.RRTgBn8h4LFHCMXBq2Rg:hover {
    background-color: #f8f9fa;
}

.RRTgBn8h4LFHCMXBq2Rg:focus-visible {
    outline: 3px solid rgba(0, 123, 255, 0.25);
    outline-offset: 2px;
}

/* Specific cell styling with optimized widths */
.WRlG8Lnx72fdgvOnYPDQ {
    width: 1px;
    white-space: nowrap;
    font-family: monospace;
    font-size: 13px;
    font-weight: 600;
    color: #2c3e50;
    padding: 12px 8px;
}

.k7YDql9__xgQXl9gv0IJ {
    width: 100%;
}

.kK7eML8Yu_ZUJnBKz8Av {
    line-height: 1.5;
    padding: 8px 12px;
    background-color: #f8f9fa;
    border-radius: 6px;
    border-left: 3px solid #007bff;
    font-size: 14px;
    white-space: pre-wrap;
    word-break: break-word;
    max-height: none;
}

.Rowk3n428DK5gLdXPM0l {
    width: 1px;
    white-space: nowrap;
    font-family: monospace;
    font-size: 12px;
    font-weight: 600;
    color: #6c757d;
    padding: 12px 8px;
}

.MEJDEpeYXfeqrtY3YzGY {
    width: 1px;
    white-space: nowrap;
    font-size: 12px;
    color: #6c757d;
    padding: 12px 8px;
}

.MUt2RoxSPSQ3zlfoWbWt {
    width: 1px;
    white-space: nowrap;
    padding: 12px 8px;
}

/* Responsive design */
@media (max-width: 1200px) {
    .WRlG8Lnx72fdgvOnYPDQ {
        width: 1px;
    }
    
    .k7YDql9__xgQXl9gv0IJ {
        width: 100%;
    }
    
    .Rowk3n428DK5gLdXPM0l {
        width: 1px;
    }
    
    .MEJDEpeYXfeqrtY3YzGY {
        width: 1px;
    }

    .MUt2RoxSPSQ3zlfoWbWt {
        width: 1px;
    }
}

@media (max-width: 768px) {
    .uIDS72ObF_2FMo3aTZ1w {
        font-size: 12px;
    }
    
    .uIDS72ObF_2FMo3aTZ1w th,
    .uIDS72ObF_2FMo3aTZ1w td {
        padding: 8px 6px;
    }
    
    .kK7eML8Yu_ZUJnBKz8Av {
        padding: 6px 10px;
        font-size: 13px;
    }
    
    .WRlG8Lnx72fdgvOnYPDQ {
        width: 1px;
        padding: 8px 4px;
    }
    
    .k7YDql9__xgQXl9gv0IJ {
        width: 100%;
        min-width: 200px;
    }
    
    .Rowk3n428DK5gLdXPM0l {
        width: 1px;
        padding: 8px 4px;
    }
    
    .MEJDEpeYXfeqrtY3YzGY {
        width: 1px;
        padding: 8px 4px;
    }

    .MUt2RoxSPSQ3zlfoWbWt {
        width: 1px;
        padding: 8px 4px;
    }
}`, "",{"version":3,"sources":["webpack://./pages/CRM/components/List/style.module.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,uBAAuB;IACvB,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,6BAA6B;IAC7B,SAAS;IACT,QAAQ;IACR,yBAAyB;IACzB,uBAAuB;IACvB,8BAA8B;IAC9B,wBAAwB;IACxB,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,iBAAiB;AACrB;;AAEA,qBAAqB;AACrB;IACI,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;IAClB,wCAAwC;AAC5C;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,iBAAiB;IACjB,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;IACzB,gCAAgC;AACpC;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;IAChB,cAAc;IACd,gCAAgC;AACpC;;AAEA;IACI,kBAAkB;IAClB,gCAAgC;IAChC,mBAAmB;IACnB,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;AACvB;;AAEA,yCAAyC;AACzC;IACI,aAAa;IACb,4CAA4C;IAC5C,SAAS;IACT,kBAAkB;IAClB,yBAAyB;IACzB,gBAAgB;IAChB,cAAc;IACd,gCAAgC;IAChC,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,4CAA4C;IAC5C,SAAS;IACT,kBAAkB;IAClB,kBAAkB;IAClB,iBAAiB;IACjB,gCAAgC;IAChC,eAAe;IACf,qBAAqB;IACrB,cAAc;IACd,8CAA8C;AAClD;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,0CAA0C;IAC1C,mBAAmB;AACvB;;AAEA,gDAAgD;AAChD;IACI,UAAU;IACV,mBAAmB;IACnB,sBAAsB;IACtB,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,yBAAyB;IACzB,kBAAkB;IAClB,8BAA8B;IAC9B,eAAe;IACf,qBAAqB;IACrB,sBAAsB;IACtB,gBAAgB;AACpB;;AAEA;IACI,UAAU;IACV,mBAAmB;IACnB,sBAAsB;IACtB,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,UAAU;IACV,mBAAmB;IACnB,eAAe;IACf,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,UAAU;IACV,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA,sBAAsB;AACtB;IACI;QACI,UAAU;IACd;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,UAAU;IACd;;IAEA;QACI,UAAU;IACd;;IAEA;QACI,UAAU;IACd;AACJ;;AAEA;IACI;QACI,eAAe;IACnB;;IAEA;;QAEI,gBAAgB;IACpB;;IAEA;QACI,iBAAiB;QACjB,eAAe;IACnB;;IAEA;QACI,UAAU;QACV,gBAAgB;IACpB;;IAEA;QACI,WAAW;QACX,gBAAgB;IACpB;;IAEA;QACI,UAAU;QACV,gBAAgB;IACpB;;IAEA;QACI,UAAU;QACV,gBAAgB;IACpB;;IAEA;QACI,UAAU;QACV,gBAAgB;IACpB;AACJ","sourcesContent":[".smsCounterButton {\n    position: relative;\n    background: transparent;\n    cursor: pointer;\n    padding: 12px;\n    border-radius: 100%;\n    border: 1px solid black;\n}\n\n.smsCounterButton:hover {\n    border-color: #f26c3a !important;\n}\n\n.tag {\n    position: absolute !important;\n    bottom: 0;\n    right: 0;\n    line-height: 0 !important;\n    height: 18px !important;\n    border-radius: 100% !important;\n    display: flex !important;\n    align-items: center;\n    justify-content: center;\n    font-size: 11px;\n    font-weight: bold;\n}\n\n/* SMS Table Styles */\n.tableContainer {\n    overflow-x: auto;\n    margin-top: 20px;\n    border-radius: 8px;\n    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n}\n\n.smsTable {\n    width: 100%;\n    border-collapse: collapse;\n    background: white;\n    font-size: 14px;\n    table-layout: auto;\n}\n\n.smsTable thead {\n    background-color: #f8f9fa;\n    border-bottom: 2px solid #dee2e6;\n}\n\n.smsTable th {\n    padding: 12px 16px;\n    text-align: left;\n    font-weight: 600;\n    color: #495057;\n    border-bottom: 1px solid #dee2e6;\n}\n\n.smsTable td {\n    padding: 12px 16px;\n    border-bottom: 1px solid #dee2e6;\n    vertical-align: top;\n    overflow-wrap: break-word;\n    word-wrap: break-word;\n}\n\n.smsTable tbody tr:hover {\n    background-color: #f8f9fa;\n}\n\n.smsTable tbody tr:last-child td {\n    border-bottom: none;\n}\n\n/* List-based layout for clickable rows */\n.listHeader {\n    display: grid;\n    grid-template-columns: 140px 1fr 180px 120px;\n    gap: 12px;\n    padding: 12px 16px;\n    background-color: #f8f9fa;\n    font-weight: 600;\n    color: #495057;\n    border-bottom: 2px solid #dee2e6;\n    font-size: 13px;\n}\n\n.listBody {\n    display: flex;\n    flex-direction: column;\n}\n\n.listRow {\n    display: grid;\n    grid-template-columns: 140px 1fr 180px 120px;\n    gap: 12px;\n    align-items: start;\n    padding: 12px 16px;\n    background: white;\n    border-bottom: 1px solid #dee2e6;\n    cursor: pointer;\n    text-decoration: none;\n    color: inherit;\n    transition: background-color 0.12s ease-in-out;\n}\n\n.listRow:hover {\n    background-color: #f8f9fa;\n}\n\n.listRow:focus-visible {\n    outline: 3px solid rgba(0, 123, 255, 0.25);\n    outline-offset: 2px;\n}\n\n/* Specific cell styling with optimized widths */\n.phoneCell {\n    width: 1px;\n    white-space: nowrap;\n    font-family: monospace;\n    font-size: 13px;\n    font-weight: 600;\n    color: #2c3e50;\n    padding: 12px 8px;\n}\n\n.messageCell {\n    width: 100%;\n}\n\n.messageContent {\n    line-height: 1.5;\n    padding: 8px 12px;\n    background-color: #f8f9fa;\n    border-radius: 6px;\n    border-left: 3px solid #007bff;\n    font-size: 14px;\n    white-space: pre-wrap;\n    word-break: break-word;\n    max-height: none;\n}\n\n.prospectCell {\n    width: 1px;\n    white-space: nowrap;\n    font-family: monospace;\n    font-size: 12px;\n    font-weight: 600;\n    color: #6c757d;\n    padding: 12px 8px;\n}\n\n.dateCell {\n    width: 1px;\n    white-space: nowrap;\n    font-size: 12px;\n    color: #6c757d;\n    padding: 12px 8px;\n}\n\n.agentCell {\n    width: 1px;\n    white-space: nowrap;\n    padding: 12px 8px;\n}\n\n/* Responsive design */\n@media (max-width: 1200px) {\n    .phoneCell {\n        width: 1px;\n    }\n    \n    .messageCell {\n        width: 100%;\n    }\n    \n    .prospectCell {\n        width: 1px;\n    }\n    \n    .dateCell {\n        width: 1px;\n    }\n\n    .agentCell {\n        width: 1px;\n    }\n}\n\n@media (max-width: 768px) {\n    .smsTable {\n        font-size: 12px;\n    }\n    \n    .smsTable th,\n    .smsTable td {\n        padding: 8px 6px;\n    }\n    \n    .messageContent {\n        padding: 6px 10px;\n        font-size: 13px;\n    }\n    \n    .phoneCell {\n        width: 1px;\n        padding: 8px 4px;\n    }\n    \n    .messageCell {\n        width: 100%;\n        min-width: 200px;\n    }\n    \n    .prospectCell {\n        width: 1px;\n        padding: 8px 4px;\n    }\n    \n    .dateCell {\n        width: 1px;\n        padding: 8px 4px;\n    }\n\n    .agentCell {\n        width: 1px;\n        padding: 8px 4px;\n    }\n}"],"sourceRoot":""}]);
// Exports
export var smsCounterButton = `hyU759h1UcxdEVdyH1EU`;
export var tag = `tZkDC54xmjhwl9JtfyTQ`;
export var tableContainer = `wUViEn29ROj0pMTpMs7M`;
export var smsTable = `uIDS72ObF_2FMo3aTZ1w`;
export var listHeader = `ekLUMPhFM913BP5paZ21`;
export var listBody = `ssf6aObccUJtdprzgo2c`;
export var listRow = `RRTgBn8h4LFHCMXBq2Rg`;
export var phoneCell = `WRlG8Lnx72fdgvOnYPDQ`;
export var messageCell = `k7YDql9__xgQXl9gv0IJ`;
export var messageContent = `kK7eML8Yu_ZUJnBKz8Av`;
export var prospectCell = `Rowk3n428DK5gLdXPM0l`;
export var dateCell = `MEJDEpeYXfeqrtY3YzGY`;
export var agentCell = `MUt2RoxSPSQ3zlfoWbWt`;
export default ___CSS_LOADER_EXPORT___;
